import { Config } from '@flowwai-frontend/bps-officer-web/env-config'

import { flowwWebAppMobileScreenConfig } from './floww'
import { maAndUdWebAppMobileScreenConfig } from './ma&udAdmin'
import { apMaAndUdWebAppMobileScreenConfig } from './ap_ma&ud'
import { ClientType, ClientWebAppMobileConfigType } from './types'

const useClientWebAppMobileScreenConfig = (): ClientWebAppMobileConfigType => {
   const clientEnum: ClientType = Config.APP_CLIENT_ENUM

   switch (clientEnum) {
      case 'FLOWW':
         return flowwWebAppMobileScreenConfig
      case 'AP_MA&UD':
         return apMaAndUdWebAppMobileScreenConfig
      case 'MA&UD':
      case 'MA&UD_ADMIN':
         return maAndUdWebAppMobileScreenConfig
      default:
         return flowwWebAppMobileScreenConfig
   }
}

export default useClientWebAppMobileScreenConfig
